<script>
import { ArticleTag } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'ArticleTag List' }
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Nazwa',
            modelPath: [this, 'form', 'name'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id
          }),
          new fields.Input({
            label: 'Opis',
            type: 'textarea',
            modelPath: [this, 'form', 'description'],
            multilingual: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return ArticleTag
    }
  }
}
</script>
